import { MutationTuple, useMutation } from '@apollo/client';
import { DuplicateOvertime, DuplicateOvertimeVariables } from './__generated__/graphql';
import { DUPLICATE_OVERTIME } from './graphql';

const useDuplicateOvertime = (): MutationTuple<DuplicateOvertime, DuplicateOvertimeVariables> => {
  return useMutation<DuplicateOvertime, DuplicateOvertimeVariables>(DUPLICATE_OVERTIME);
};

export default useDuplicateOvertime;
